/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pleaseselectapricetype4Inputs */

const en_pleaseselectapricetype4 = /** @type {(inputs: Pleaseselectapricetype4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please select a price type`)
};

const de_pleaseselectapricetype4 = /** @type {(inputs: Pleaseselectapricetype4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte wähl eine Preisart`)
};

/**
* | output |
* | --- |
* | "Please select a price type" |
*
* @param {Pleaseselectapricetype4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const pleaseselectapricetype4 = /** @type {((inputs?: Pleaseselectapricetype4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pleaseselectapricetype4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pleaseselectapricetype4(inputs)
	return de_pleaseselectapricetype4(inputs)
});
export { pleaseselectapricetype4 as "pleaseSelectAPriceType" }